var productionMode = false;
var environment = 'staging'
var serverUrl = 'https://mon.qtrust.id:40013';
var serviceName = 'dso-dashboard-pg-test';
var secretToken = 'PpUw5ZibLVZFORV';
const gaId = 'G-Y6PBKZPFNJ';
const urlStart = 'https://sdso-dash.qtrust.id';
export default {gaId, productionMode, environment, serverUrl, serviceName, secretToken, urlStart};
